import React from 'react';
import {
  LabourCostRate,
  LabourCostRateUserOverride,
  LabourBillingRate,
} from 'api/labourApi';
import AddOrEditLabourCostRateDialog from './AddOrEditLabourCostRateDialog';
import AddOrEditLabourCostRateOverrideDialog from './AddOrEditLabourCostRateOverrideDialog';
import AddOrEditLabourBillingRateDialog from './AddOrEditLabourBillingRateDialog';

interface AddLabourRatesProps {
  handleCostRateFormClose: () => void;
  handleCostRateOverrideFormClose: () => void;
  handleBillingRateFormClose: () => void;
  openCostRateForm: boolean;
  openCostRateOverrideForm: boolean;
  openBillingRateForm: boolean;
  editCostRate?: LabourCostRate | null;
  editCostRateOverride?: LabourCostRateUserOverride | null;
  editBillingRate?: LabourBillingRate | null;
  onClearEditCostRate?: () => void;
  onClearEditCostRateOverride?: () => void;
  onClearEditBillingRate?: () => void;
}

export default function AddLabourRates({
  handleCostRateFormClose,
  handleCostRateOverrideFormClose,
  handleBillingRateFormClose,
  openCostRateForm,
  openCostRateOverrideForm,
  openBillingRateForm,
  editCostRate = null,
  editCostRateOverride = null,
  editBillingRate = null,
  onClearEditCostRate,
  onClearEditCostRateOverride,
  onClearEditBillingRate,
}: AddLabourRatesProps) {
  const handleCostRateClose = () => {
    handleCostRateFormClose();
    onClearEditCostRate?.();
  };

  const handleCostRateOverrideClose = () => {
    handleCostRateOverrideFormClose();
    onClearEditCostRateOverride?.();
  };

  const handleBillingRateClose = () => {
    handleBillingRateFormClose();
    onClearEditBillingRate?.();
  };

  return (
    <>
      <AddOrEditLabourCostRateDialog
        open={openCostRateForm}
        onClose={handleCostRateClose}
        editItem={editCostRate}
        onClearEdit={onClearEditCostRate}
      />
      <AddOrEditLabourCostRateOverrideDialog
        open={openCostRateOverrideForm}
        onClose={handleCostRateOverrideClose}
        editItem={editCostRateOverride}
        onClearEdit={onClearEditCostRateOverride}
      />
      <AddOrEditLabourBillingRateDialog
        open={openBillingRateForm}
        onClose={handleBillingRateClose}
        editItem={editBillingRate}
        onClearEdit={onClearEditBillingRate}
      />
    </>
  );
}
